export interface IFieldDesignProps {
  hasError?: boolean;
}

export interface IStyledFieldDesignProps {
  $hasError?: boolean;
}

export enum EmailInputError {
  Duplicate = 'duplicate',
  Domain = 'domain',
  Format = 'format',
}
